import { useEffect, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { AxiosError } from "axios";
import {
  Button,
  FormContainerControlled,
  TextFieldHookForm,
  Typography,
} from "components";
import { gray, primary } from "configs/colors";
import { emailRequired, passwordRequired, stringRequired } from "helpers/yup";
import { useLogin } from "libs/auth";
import { useForm } from "react-hook-form";
import * as Yup from "yup";

import content from "./assets/images/content.png";
import {
  ContentImage,
  FormContainer,
  LeftSection,
  PageContainer,
  RightSection,
} from "./styles";

interface LoginProps {
  email: string;
  password: string;
}
interface Props {
  setIsLoginPassword: any;
}

const formLogin = Yup.object({
  email: emailRequired,
  password: stringRequired,
});

const LoginFrom = (props: Props) => {
  const { setIsLoginPassword } = props;
  const [errorLogin, setErrorLogin] = useState<string>("");
  const { mutate: login, isLoading: isLoggingIn, error } = useLogin();
  const theme = useTheme();
  const mdUpMatched = useMediaQuery(theme.breakpoints.up("md"));
  const methods = useForm<LoginProps | any>({
    mode: "onSubmit",
    resolver: yupResolver(formLogin),
  });
  const onSubmit = (data: LoginProps) => {
    // eslint-disable-next-line
    login({
      username: data?.email,
      password: data?.password,
    });
  };
  useEffect(() => {
    if (error instanceof AxiosError) {
      let messageError = error?.response?.data?.message;
      // eslint-disable-next-line
      messageError = Object.values(messageError)[0];
      if (messageError === "Invalid user.") {
        setErrorLogin(
          "The email address you entered is not in our system. Please try again with a different email address!"
        );
      }
    }
  }, [error]);
  return (
    <>
      {/* <SEO title="Sign In" /> */}
      <PageContainer>
        <LeftSection mdUpMatched={mdUpMatched}>
          <Box
            margin={2}
            flex={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <FormContainer>
              <FormContainerControlled methods={methods} onSubmit={onSubmit}>
                <Typography type="DisplayMD" fontWeight={600} color={gray[900]}>
                  Log in
                </Typography>
                <Typography
                  type="TextMD"
                  color={gray[600]}
                  marginTop={3}
                  marginBottom={8}
                >
                  Welcome back! Please enter your credential.
                </Typography>
                <Stack gap={6} marginBottom={5}>
                  <TextFieldHookForm
                    label="Email"
                    placeholder="Enter your email"
                    name="email"
                    required
                    helperText={errorLogin}
                    error={!!errorLogin}
                    setError={setErrorLogin}
                  />
                </Stack>
                <Stack gap={6} marginBottom={6}>
                  <TextFieldHookForm
                    label="Password"
                    type="password"
                    placeholder="Enter your password"
                    name="password"
                    required
                    helperText={errorLogin}
                    error={!!errorLogin}
                    setError={setErrorLogin}
                  />
                </Stack>

                <Stack gap={6} marginBottom={6}>
                  <Button
                    variant="outlined"
                    size="lg"
                    useTypography
                    sx={{
                      ".MuiTypography-root": {
                        fontSize: "14px",
                        lineHeight: "20px",
                      },
                      padding: "10px 16px",
                      background: primary[50],
                    }}
                    type="submit"
                    loading={isLoggingIn || methods.formState.isSubmitting}
                  >
                    {isLoggingIn || methods.formState.isSubmitting
                      ? "Loading ..."
                      : "Sign in"}
                  </Button>
                </Stack>
                <Stack
                  display="flex"
                  direction="row"
                  alignItems="center"
                  justifyContent="end"
                  gap={2}
                >
                  <Typography
                    type="TextSM"
                    fontWeight={600}
                    color={primary[700]}
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      // eslint-disable-next-line
                      setIsLoginPassword(false);
                    }}
                  >
                    Login with OTP
                  </Typography>
                </Stack>
              </FormContainerControlled>
            </FormContainer>
          </Box>
          <Box padding={mdUpMatched ? 8 : 2}>
            <Typography
              type="TextSM"
              color={mdUpMatched ? gray[600] : primary[200]}
            >
              © Talentnet 2023
            </Typography>
          </Box>
        </LeftSection>
        {mdUpMatched ? (
          <RightSection>
            <ContentImage src={content} alt="Content" />
          </RightSection>
        ) : null}
      </PageContainer>
    </>
  );
};

export default LoginFrom;
